/* eslint-disable jsdoc/require-param-type */
/* eslint-disable jsdoc/require-param-description */
/* eslint-disable jsdoc/require-returns */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */
import { Action } from '@ngrx/store';
import { ActionTypes } from '../actions/my-account.action';

export interface PayloadAction extends Action {
    payload?: any; // Use a specific type instead of `any` if possible
}
/**
 *
 * @param state
 * @param action
 */
export function myProfileReducer(state = {}, action: PayloadAction) {
    switch (action.type) {
    case ActionTypes.LoadProfile:
        return state;
    case ActionTypes.LoadProfileComplete:
        return action.payload;
    default: {
        return state;
    }
    }
}
